<template>
  <v-data-table :headers="headers" :items="licitacionParticipantes">
    <template v-slot:[`item.createdAt`]="{ item }">
      <fecha-humano :fecha="item.createdAt"> </fecha-humano>
    </template>
    <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoParticipantesLicitacionDesktop',
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Razón Social',
          sortable: false,
          value: 'contratista.nombreRazonSocial',
        },
        {
          text: 'RFC',
          align: 'start',
          sortable: false,
          value: 'contratista.rfc',
        },
        { text: 'Representante', value: 'contratista.nombreRepresentante' },
        { text: 'Correo Electrónico', value: 'contratista.correoElectronico' },
        { text: 'Fecha de Registro', value: 'createdAt' },
        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  methods: {
    borrar(participanteLicitacion) {
      eventBus.$emit('eliminar-participante', participanteLicitacion);
    },
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
};
</script>

<style lang="scss">
</style>
